"use script"

angular.module("vendor")
.controller("ShippingRateEditController", function(
    $scope, $state, $stateParams, ShippingRateService, FlashBag, $q, FormError, UnitsOfMeasureService,
    SHIPPING_RATE_METHOD_PER_ORDER, SHIPPING_RATE_METHOD_PER_AMOUNT, SHIPPING_RATE_METHOD_PER_REGION_AND_WEIGHT
) {
    var unregisterLanguageChanged = $scope.$on("LanguageChanged", function(evt, new_locale, new_language) {
        $scope.methods = ShippingRateService.getShippingRateMethod();
    });
    $scope.$on("$destroy", function() {
        unregisterLanguageChanged();
    });

    this.PER_ORDER = SHIPPING_RATE_METHOD_PER_ORDER;
    this.PER_AMOUNT = SHIPPING_RATE_METHOD_PER_AMOUNT;
    this.PER_REGION_AND_WEIGHT = SHIPPING_RATE_METHOD_PER_REGION_AND_WEIGHT;

    $scope.methods = ShippingRateService.getShippingRateMethod();
    $scope.ShippingRateService = ShippingRateService;

    $scope.shippingRateId = $stateParams.id;
    $scope.shippingRate = {
        zones: [],
        rules: [{}]
    };

    $scope.unitOfMeasures = UnitsOfMeasureService.query();

    this.limitRuleTo = function() {
        if ($scope.shippingRate.method === SHIPPING_RATE_METHOD_PER_ORDER) {
            return 1;
        }
    };

    this.getUnitOfMeasureCodeById = function(id) {
        var unitOfMeasureCode;
        angular.forEach($scope.unitOfMeasures, function(value) {
            if (id === value.id) {
                unitOfMeasureCode = value.code;
            }
        });
        return unitOfMeasureCode;
    };

    this.getShippingRate = function() {
        if ($scope.shippingRateId) {
            ShippingRateService.get($scope.shippingRateId)
            .$promise.then(function onSuccess(data) {
                $scope.shippingRate = data;
            });
        }
    };

    this.addRule = function() {
        $scope.shippingRate.rules.push({});
    };

    this.removeRule = function(rule) {
        var index = $scope.shippingRate.rules.indexOf(rule);
        $scope.shippingRate.rules.splice(index, 1);
    };

    this.save = function() {
        var deferred = $q.defer();

        $scope.formShippingRate.$setSubmitted();
        FlashBag.clearAll();

        if (
            (
                $scope.shippingRate.method === SHIPPING_RATE_METHOD_PER_REGION_AND_WEIGHT
                && $scope.shippingRate.zones
                && $scope.formShippingRate.$valid
            ) || (
                $scope.shippingRate.method !== SHIPPING_RATE_METHOD_PER_REGION_AND_WEIGHT
                && $scope.formShippingRate.$valid
            )
        ) {
            if (
                $scope.shippingRate.method === SHIPPING_RATE_METHOD_PER_REGION_AND_WEIGHT
                && $scope.shippingRate.zones
            ) {
                $scope.shippingRate.zone_keys = this.makeZonesKey($scope.shippingRate.zones);
            }

            var promise;
            if ($scope.shippingRateId) {
                promise = ShippingRateService.update($scope.shippingRate);
            }
            else {
                promise = ShippingRateService.create($scope.shippingRate);
            }

            promise.then(
                function onSuccess(response) {
                    deferred.resolve(response);
                },
                function onError(response) {
                    FlashBag.apiError(response);
                    deferred.reject(response);
                }
            );
        }
        else {
            FormError.focus("formShippingRate");
            deferred.reject(true);
        }

        return deferred.promise;
    };

    this.makeZonesKey = function(zones) {
        var key = "";
        if (zones) {
            for (var i = 0; i !== zones.length; i++) {
                key += zones[i].id + ";";
            }
            key = key.slice(0, -1);
        }

        return key;
    };

    this.getShippingRate();
});



//////////////////
// WEBPACK FOOTER
// ./vendor/sections/shipping-rate/shipping-rate-edit.controller.js
// module id = 1016
// module chunks = 0